import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation('snapForm');
  return <div>{t('form.notFound')}</div>;
};

export default NotFound;
